import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { Redirect } from 'react-router-dom';




import TopBar from "../components/TopBar";
import Sidebar from "../components/Sidebar";


import { getProfile, updateProfile, resetProfileUpdated, resetErrorMessage, addProfileImage } from "../store/actions/profileActions";

function Profile(props) {

    const { token, profile, profile_updated, error_message, getProfileFN, updateProfileFN, resetProfileUpdatedFN, resetErrorMessageFN, addProfileImageFN } = props;


    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [profileImage, setProfileImage] = useState(null);

    const handleImageChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            const fileType = file.type;

            // Check if the file is an image
            if (fileType.startsWith('image/')) {
                setProfileImage(URL.createObjectURL(file));
                addProfileImageFN(file);
            } else {
                setError("Please upload a valid image file.");
            }
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Handle form submission logic here (e.g., dispatch an action to update user profile)
        updateProfileFN({ first_name: firstName, last_name: lastName, avatar: profileImage });
        ////console.log("Profile updated:", { firstName, lastName, profileImage });
    };



    useEffect(() => {
        getProfileFN();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (profile) {

            ////console.log(profile);


            setFirstName(profile.first_name);
            setLastName(profile.last_name);
            setProfileImage(profile.avatar);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [profile]);

    useEffect(() => {
        if (profile_updated) {
            setSuccess("Profile updated successfully!");
            resetProfileUpdatedFN();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [profile_updated]);

    useEffect(() => {
        if (error_message) {
            setError(error_message);
            resetErrorMessageFN();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [error_message]);



    return token ? (

        <div className="flex flex-col w-full h-screen overflow-hidden">
            <TopBar className="fixed top-0 left-0 right-0 z-10" />
            <div className="flex flex-row w-full h-full">
                <Sidebar className="fixed top-0 left-0 h-screen pt-[64px] z-0" /> {/* Adjust the top to match TopBar height */}
                <div id="dashboard-content" className="flex flex-col w-full p-4 overflow-auto"
                > {/* Adjust the margin-left to match Sidebar width */}

                    <form onSubmit={handleSubmit} className="flex flex-col space-y-4 p-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700">First Name</label>
                            <input
                                type="text"
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value)}
                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                                required
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Last Name</label>
                            <input
                                type="text"
                                value={lastName}
                                onChange={(e) => setLastName(e.target.value)}
                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                                required
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Profile Image</label>
                            {profileImage && <img src={profileImage} alt="Profile Preview" className="mt-2 mb-2 w-12 h-12 object-cover rounded-full" />}

                            <input
                                type="file"
                                accept="image/*"
                                onChange={handleImageChange}
                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                            />
                        </div>
                        <button type="submit" className="mt-4 bg-[#3b3b3b] text-white p-2 rounded-md w-64 hover:opacity-80 transition-opacity">Update Profile</button>
                    </form>
                    {error && <div className="text-red-500 p-4">{error}</div>}
                    {success && <div className="text-green-500 p-4">{success}</div>}
                </div>
            </div>
        </div>
    ) : <Redirect to="/login" />;

}

const mapStateToProps = (state) => {
    return {

        token: state.auth.token,
        profile: state.profile.profile,
        profile_updated: state.profile.profile_updated,
        error_message: state.profile.error_message,


    };
};

const mapDispatchToProps = (dispatch) => {
    return {

        getProfileFN: () => dispatch(getProfile()),
        updateProfileFN: (profile) => dispatch(updateProfile(profile)),
        resetProfileUpdatedFN: () => dispatch(resetProfileUpdated()),
        resetErrorMessageFN: () => dispatch(resetErrorMessage()),
        addProfileImageFN: (file) => dispatch(addProfileImage(file)),
    };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(Profile);
